import { create } from "zustand"
import sortOrder from "lodash/orderBy"

import { useCurrentSessionStore } from "./useCurrentSessionStore"

export const useUserStore = create((set, get) => ({
  currentUser: null,
  userSettings: {},
  userNoteSettings: null,
  userTechniques: null,
  userClients: null,
  userDrafts: null,
  setCurrentUser: (payload) => {
    if (payload) {
      set({ currentUser: payload })
    } else {
      set({
        currentUser: null,
        userNoteSettings: null,
        userTechniques: null,
        userDrafts: null,
        userClients: null,
        userSettings: {},
      })
    }
  },
  setUserNoteSettings: (payload) => {
    const prevNoteSettings = get().userNoteSettings
    if (!prevNoteSettings) {
      const currentNote = payload?.find((n) => n.orderIndex < 1)
      useCurrentSessionStore.getState().setInitialCurrentNote(currentNote)
    }
    set({
      userNoteSettings: payload,
    })
  },
  setUserSettings: (payload) => {
    set({
      userSettings: {},
    })
  },
  clearUserSettings: () => {
    set({
      userNoteSettings: null,
      userTechniques: null,
      userSettings: {},
    })
  },
  setUserTechniques: (payload) =>
    set({
      userTechniques: payload,
    }),
  setUserClients: (payload) =>
    set({
      userClients: payload,
    }),
  setUserDrafts: (payload) =>
    set({
      userDrafts: payload,
    }),
}))
